export const useStyles = () => {
    return {
        styles: {
            container: {
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "100%",
            },
            inputs: {
                display: 'flex',
                paddingRight: "16px",
                gap: "16px",
                flexDirection: { xs: "column", md: "row" },
                "& .MuiTextField-root": {
                    display: "flex",
                    flex: 1,
                    background: "transparent"
                },
            }
        }
    }
}